import { gql } from 'react-apollo';

export default gql`
  query allUserInvestments($query: QueryInput!) {
    allUserInvestments(query: $query) {
      _id
      items {
        _id
        investmentAmount
        investmentAmountCrypto
        agreementEnvelopeId
        brokerageAgreementEnvelopeId
        sharesOrTokensPurchased
        investmentStatus
        createdAt
        paymentType
        paymentMethod
        investmentReviewAgreement
        closingDateAgreement
        offer {
          _id
          name
          status
          visibility
          listingType
          typeOfOffer
          issuerCompany {
            _id
            name
          }
        }
      }
      total
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/queries/allUserInvestments.js